import clsx from "clsx";
import React from "react";
import { Box, BoxProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { usePreview } from "../../hooks/usePreview";
import { colorSystem } from "../../theme";
import { PREVIEW_BAR_SPACING } from "./PreviewBar";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: colorSystem.secondaryGray,
    borderRadius: theme.spacing(3),
    width: "max-content",
    margin: 0,
    position: "relative",
    marginBlock: "auto",
  },

  pageContainer: {
    backgroundColor: theme.palette.background.default,
    containerType: "inline-size",
    containerName: "previewBox",
    overflowY: "scroll",
    overflowX: "clip",

    "&$mobile": {
      margin: theme.spacing(6, 1),

      width: 297,
      height: 522,
    },

    "&$tablet": {
      margin: theme.spacing(3),

      "&::after": {
        width: 980,
        left: -60,
      },

      width: 540,
      height: 720,
    },

    "&$web": {
      borderRadius: 0,
      width: "100vw",
      height: `calc(100vh - ${theme.spacing(PREVIEW_BAR_SPACING)})`,
      transform: "none",

      "&::after": {
        display: "none",
      },
    },
  },

  mobile: {},
  tablet: {},
  web: {},
}));

export interface PreviewBoxProps extends BoxProps {
  src?: string;
}

export function PreviewBox(props: PreviewBoxProps) {
  const { className, src, children, ...other } = props;
  const s = useStyles();
  const [preview] = usePreview();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <Box className={clsx(s.pageContainer, s[preview.toLowerCase()])}>
        {children}
      </Box>
    </Box>
  );
}
